import React from "react";
import { useTheme } from "../../hooks";
import { LinkStyled } from "./LinkStyles";
export const Link = ({ styles = {}, ...rest }) => {
    const { Theme } = useTheme();
    const StylesOverride = { ...Theme.link, ...styles };
    return React.createElement(LinkStyled, { styles: StylesOverride, ...rest });
};
export default Link;
//# sourceMappingURL=Link.js.map